module.exports = __webpack_public_path__ + "static/media/checked-w.1bdc6a29.svg";